import React from 'react';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';

const ArrowSeparator = ({ direction = 'down' }) => {
  return (
    <div className="flex justify-center my-6">
      {direction === 'down' ? (
        <FaArrowDown className="text-orange-400 text-4xl animate-bounce" />
      ) : (
        <FaArrowUp className="text-orange-400 text-4xl animate-bounce" />
      )}
    </div>
  );
};

export default ArrowSeparator;
